import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const GameSelection = ({ games, onSelectGame }) => {
  const { isDark } = useTheme();

  const cardBg     = isDark ? 'bg-[#0D1520]'   : 'bg-white';
  const cardBorder = isDark ? 'border-[#1E3A5F]' : 'border-[var(--border-color)]';
  const titleClr   = isDark ? 'text-white'     : 'text-gray-800';
  const descClr    = isDark ? 'text-slate-400'  : 'text-gray-600';
  const btnBg      = isDark 
    ? 'bg-blue-600 text-white hover:bg-blue-500' 
    : 'bg-blue-600 text-white hover:bg-blue-700';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {games.map((game) => (
        <div
          key={game.id}
          className={`pixel-border ${cardBg} ${cardBorder} p-6 flex flex-col items-center justify-between text-center transition-all duration-300 hover:-translate-y-1`}
        >
          <div className="flex flex-col items-center w-full">
            <div className="text-4xl mb-4">{game.icon}</div>
            <h3 className={`text-xl font-bold ${titleClr} mb-2 pixel-font`}>
              {game.name}
            </h3>
            <p className={`${descClr} text-sm mb-6 leading-relaxed`}>
              {game.description}
            </p>
          </div>

          <button
            onClick={() => onSelectGame(game.id)}
            className={`pixel-button ${btnBg} px-6 py-2 text-sm font-bold pixel-font tracking-wider w-full`}
          >
            PLAY
          </button>
        </div>
      ))}
    </div>
  );
};

export default GameSelection;